"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const subscriber_1 = require("./subscriber");
function subscribe(dependOn) {
    return function (dependent, funName, descriptor) {
        if (!descriptor.value || !(dependent instanceof subscriber_1.Subscriber)) {
            throw new Error("You can put depend decorator only on a function from Subscriber instance");
        }
        subscriber_1.Subscriber._functions_to_updates.push(descriptor.value);
        return descriptor;
    };
}
exports.subscribe = subscribe;
//# sourceMappingURL=subscribe.js.map